<mat-card class="example-card">
  <mat-card-header class="card-header">
    <mat-card-title>Mis Incidencias</mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
      <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    </div>

    <ng-container *ngIf="canView">

      <mat-expansion-panel class="search-label">

        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon style="margin-top: -3px;">search</mat-icon> Filtros de Búsqueda
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <form [formGroup]="searchForm">

          <div fxLayout="row stretch" fxLayout.xs="column">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isCategoriaSearching">Categoría</mat-label>
                <mat-label *ngIf="isCategoriaSearching">Cargando...</mat-label>
                <mat-select formControlName="IncidenciaUsuarioCategoriaId">
                  <mat-option>Todas</mat-option>
                  <mat-option *ngFor="let s of categoriaList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Asunto de la Incidencia</mat-label>
                <input matInput formControlName="Asunto" (keyup.enter)="onSearch()">
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%" >
                <mat-label>Fecha Creación Desde</mat-label>
                <input matInput [matDatepicker]="fechaCreacionDesdePicker" formControlName="FechaCreacionDesde"  (click)="fechaCreacionDesdePicker.open()">
                <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaCreacionDesdePicker">
                </mat-datepicker-toggle>
                <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaCreacionDesde')">
                  <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #fechaCreacionDesdePicker></mat-datepicker>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Fecha Creación Hasta</mat-label>
                <input matInput [matDatepicker]="fechaCreacionHastaPicker" formControlName="FechaCreacionHasta"  (click)="fechaCreacionHastaPicker.open()">
                <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaCreacionHastaPicker">
                </mat-datepicker-toggle>
                <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaCreacionHasta')">
                  <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #fechaCreacionHastaPicker></mat-datepicker>
              </mat-form-field>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isComunidadSearching">{{ 'Comunidad' | translate}}</mat-label>
                <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
                <mat-select formControlName="ComunidadId">
                  <mat-option>Todas</mat-option>
                  <mat-option *ngFor="let s of comunidadList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Nro. Incidente</mat-label>
                <input matInput formControlName="Id" (keyup.enter)="onSearch()">
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
            </div>

          </div>

        </form>

        <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px" *ngIf="!verEnviados">
          <div fxFlex=100 fxFlex.xs=100 class="flex-item" align="end">
            <mat-checkbox [(ngModel)]="verSoloNoLeidos" (keyup.enter)="onSearch()" color="primary">Ver solo no leídos</mat-checkbox>
          </div>
        </div>

      </mat-expansion-panel>

      <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px">
        <button mat-raised-button (click)="add()" *ngIf="canEdit" [disabled]="isSearching" class="zb-button">Nueva Incidencia</button>
        <button mat-raised-button (click)="onSearch()" [disabled]="isSearching" color="primary" class="zb-button">{{isSearching ? 'Buscando...' : 'Buscar'}}</button>
        <button mat-raised-button (click)="onExport()" [disabled]="isExporting" color="warn" class="zb-button">{{isExporting ? 'Exportando...' : 'Exportar'}}</button>
      </div>

      <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
        <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
      </div>

      <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isSearching" >
        <ejs-grid  #grid [dataSource]='data' [query]='query' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [pageSettings]='pageSettings' [allowResizing]='true'>
          <e-columns>
            <e-column field='Id' headerText='#' width=60></e-column>
            <e-column field='FechaUltimoMensaje' headerText='Fecha Ult. Actualización' width=60></e-column>
            <e-column field='IncidenciaUsuarioCategoriaNombre' headerText='Categoría' width=90></e-column>
            <e-column field='ComunidadNombre' headerText='Comunidad' width=90>
              <ng-template #headerTemplate let-data>
                <div>
                  {{ 'Comunidad' | translate}}
                </div>
              </ng-template>
            </e-column>
            <e-column field='EstadoNombre' headerText='Estado' width=90></e-column>
            <e-column field='Asunto' headerText='Asunto' width=120></e-column>
            <e-column headerText='Acciones' width=40>
            </e-column>
          </e-columns>
          <ng-template #rowTemplate let-data>
            <tr class="e-row {{(data.Leido ? 'message-read' : 'message-unread')}}">
              <td class="e-rowcell">{{data.Id}}</td>
              <td class="e-rowcell">{{data.FechaUltimoMensaje | date:'dd/MM/yyyy HH:mm:ss'}}</td>
              <td class="e-rowcell">{{data.IncidenciaUsuarioCategoriaNombre}}</td>
              <td class="e-rowcell">{{data.ComunidadNombre}}</td>
              <td class="e-rowcell">{{data.EstadoNombre}}</td>
              <td class="e-rowcell">{{data.Asunto}}</td>
              <td class="e-rowcell">
                <a style="cursor: pointer; margin-right: 5px" (click)="view(data)"><i class="fa fa-eye fa-1x"></i></a>
              </td>
            </tr>
          </ng-template>
        </ejs-grid>
      </div>

    </ng-container>

  </mat-card-content>
</mat-card>

